// extracted by mini-css-extract-plugin
module.exports = {"container":"_2fStdaGs0Re06-RLKbuBak"};